// src/layouts/documents/documentTableData.js

import React from "react";
import PropTypes from "prop-types";
import Chip from "@mui/material/Chip";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import { Link } from "react-router-dom";
import { useLanguage } from "context/LanguageContext";
import { getDocumentTypeMeta } from "common/utils/documentType";

// Komponentas dokumento pavadinimui atvaizduoti - modified to be more compact
const Document = ({ title }) => (
  <MDTypography
    display="block"
    variant="button"
    fontWeight="medium"
    sx={{ maxWidth: "180px", wordBreak: "break-word" }}
  >
    {title}
  </MDTypography>
);

Document.propTypes = {
  title: PropTypes.string.isRequired,
};

// Komponentas pavadinimo ląstelės renderinimui
const TitleCell = ({ value }) => <Document title={value} />;

TitleCell.propTypes = {
  value: PropTypes.string.isRequired,
};

// Komponentas veiksmo ląstelei
const ViewButton = ({ documentId }) => {
  const { t } = useLanguage();

  return (
    <Link to={`/documents/${documentId}`}>
      <MDButton variant="gradient" color="info" size="small">
        {t("view")}
      </MDButton>
    </Link>
  );
};

ViewButton.propTypes = {
  documentId: PropTypes.number.isRequired,
};

// Komponentas veiksmo ląstelei
const ActionsCell = ({ value }) => <ViewButton documentId={value} />;

ActionsCell.propTypes = {
  value: PropTypes.number.isRequired,
};

// Naujas komponentas "Recognized" ląstelei, rodantis tik "Yes" arba "No"
const RecognizedTextCell = ({ value }) => {
  const { t } = useLanguage();

  return <MDTypography variant="body2">{value ? t("yes") : t("no")}</MDTypography>;
};

RecognizedTextCell.propTypes = {
  value: PropTypes.bool.isRequired, // Arba PropTypes.string jei reikia
};

// Funkcija, kuri grąžina duomenų struktūrą
export default function documentTableData(t) {
  const DocumentTypeCell = ({ row }) => {
    const meta = getDocumentTypeMeta(row?.original, t);
    if (!meta) return null;

    return (
      <Chip
        label={meta.label}
        color={meta.chipColor}
        variant={meta.chipVariant}
        size="small"
        sx={{ fontWeight: 500 }}
      />
    );
  };

  DocumentTypeCell.propTypes = {
    row: PropTypes.shape({
      original: PropTypes.object,
    }).isRequired,
  };

  return {
    columns: [
      {
        Header: t("title"),
        accessor: "title",
        Cell: TitleCell,
        width: 180, // Set a fixed width for the column
      },
      {
        Header: t("rec"), // Changed from "Recognized" to "Rec"
        accessor: "is_recognized",
        Cell: RecognizedTextCell,
        width: 60, // Reduced width since header is shorter
      },
      {
        Header: t("documentType"),
        accessor: "document_type",
        Cell: DocumentTypeCell,
        disableSortBy: true,
        width: 160,
      },
      {
        Header: t("supplierName"),
        accessor: "supplier_name",
      },
      {
        Header: t("supplierRegistration"),
        accessor: "supplier_registration",
      },
      {
        Header: t("receiverName"),
        accessor: "receiver_name",
      },
      {
        Header: t("receiverRegistration"),
        accessor: "receiver_registration",
      },
      {
        Header: t("invoiceId"),
        accessor: "invoice_id",
      },
      {
        Header: t("invoiceDate"),
        accessor: "invoice_date",
      },
      {
        Header: t("netAmount"),
        accessor: "net_amount",
      },
      {
        Header: t("taxAmount"),
        accessor: "total_tax_amount",
      },
      {
        Header: t("totalAmount"),
        accessor: "total_amount",
      },
      {
        Header: t("actions"),
        accessor: "id",
        Cell: ActionsCell,
        disableSortBy: true,
      },
    ],
  };
}
